import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import VueImg from 'v-img';

Vue.use(VueImg);

Vue.use(Vuetify);

export default new Vuetify({

  theme: {
    themes: {
      light: {
        primary: "#0072B9",
        secondary: "#3a3838",
        terciary: "#67AF21",
        error: "#Ed4d4d",
        success: "#008000",
        background: "#ffffff",
      },
    },
  },
});
